import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from './stores/ThemeContext';
import { TypingFontProvider } from './stores/TypingFontContext';
import { installTextareaTabIndent } from './utils/textareaTabIndent';
import './index.css';
// Mundo "Instrumento Óptico" — escopado a [data-world="instrumento"] (ficha do
// paciente). Fora desse seletor não emite nenhuma regra.
import './styles/instrumento.css';
// Visual novo "estilo Google" (spec 017) — escopado a html[data-visual="google"],
// que só existe com a chave ligada nesta máquina. Vem DEPOIS do instrumento
// porque sobrepõe a paleta e os cantos dele.
import './styles/visual-google.css';
// Agendamento do portal no celular: piso de tamanho de letra (só < 640 px,
// só dentro de [data-world="portal"]).
import './styles/portal-celular.css';
// Nova evolução enxuta (spec 026) — escopado a html[data-evolucao].
import './styles/evolucao-enxuta.css';
import { applyVisualGoogle } from './utils/visualGoogle';
import { applyEvolucaoVisual } from './utils/evolucaoVisual';

installTextareaTabIndent();
// Antes do primeiro render: sem piscar o visual antigo ao abrir.
applyVisualGoogle();
applyEvolucaoVisual();

// Auto-recupera de "chunk velho" após deploy (PWA com autoUpdate/skipWaiting):
// quando um import() dinâmico falha porque o arquivo hasheado saiu do ar na
// release nova, o Vite dispara 'vite:preloadError'. Em vez de cair no error
// boundary ("Algo deu errado"), recarrega pra pegar a versão nova. Guard por
// timestamp evita loop caso o chunk realmente tenha sumido (recarrega no
// máximo 1x a cada 10s).
window.addEventListener('vite:preloadError', () => {
  const KEY = 'dratento-chunk-reload-at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 10000) return;
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <TypingFontProvider>
        <App />
      </TypingFontProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
